/** Browser-safe source values for an organization's allowed website. */
export const OrganizationAllowedWebsiteSource = {
    LOCAL: 'LOCAL',
    TEMPLATE_REFERENCE: 'TEMPLATE_REFERENCE',
    TEMPLATE_COPY: 'TEMPLATE_COPY',
} as const;

export type OrganizationAllowedWebsiteSource =
    (typeof OrganizationAllowedWebsiteSource)[keyof typeof OrganizationAllowedWebsiteSource];
